import Admin from "../Admin";
import CardAdminOrderStatusReasonDetailGeneral from "../../../Component/Card/Admin/OrderStatusReasonDetail/CardAdminOrderStatusReasonDetailGeneral";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUISaveButton from "@mui/icons-material/Save";
import MUILoadingButton from "@mui/lab/LoadingButton";
import Menu from "../../../Component/Menu";
import DialogConfirm from "../../../Component/Dialog/DialogConfirm";
import MUIMenuItem from '@mui/material/MenuItem';
import MUIListItemIcon from '@mui/material/ListItemIcon';
import OrderStatusReasonDetailService from "../../../Seating/Settings/orderStatusReasonDetailService";
import Validator from "../../../Utility/Validator";
import OrderStatusReasonDetail from "../../../Utility/Crud/OrderStatusReasonDetail";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";

export default class AdminOrderStatusReasonDetailCreateEdit extends Admin {
    constructor(props) {
        super(props);

        this.state.orderStatusReasonDetail = null;
        this.state.isProcessing = false;
        this.state.isUpdate = !!props.match.params.id;
        this.state.confirmDialogOpen = false;
        this.state.validationIssues = {};
    }

    /**
     * Set the orderStatusReasonDetail in the state.
     */
    afterComponentDidMount() {
        const orderStatusReasonDetailId = this.props.match.params.id ? +this.props.match.params.id : null;
        if (orderStatusReasonDetailId !== null) {
            this.setState({
                orderStatusReasonDetail: this.context.orderStatusReasonDetailsIndexed[orderStatusReasonDetailId]
            });
        }
    }

    /**
     * Creates the orderStatusReasonDetail with the current properties in state.orderStatusReasonDetail.
     */
    async createOrderStatusReason() {
        this.setState({
            isProcessing: true,
        });

        return OrderStatusReasonDetailService.createOrderStatusReasonDetail(this.state.orderStatusReasonDetail)
            .then(orderStatusReasonDetail => {
                this.context.updateIndexed("orderStatusReasonDetailsIndexed", orderStatusReasonDetail);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Order Status Reason Detail created successfully!", {variant: "success"});
            })
            .catch((err) => {
                // JZ. We need to test and make sure that Sentry still captures
                // errors when we catch them in the application.
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error creating a new Order Status Reason Detail.", {variant: "error"});
                this.setState({
                    isProcessing: false,
                });
            });
    }

    /**
     * Updates the orderStatusReasonDetail with the current properties in state.orderStatusReasonDetail.
     */
    async updateOrderStatusReason() {
        this.setState({
            isProcessing: true,
        });

        return OrderStatusReasonDetailService.updateOrderStatusReasonDetail(this.state.orderStatusReasonDetail)
            .then(orderStatusReasonDetail => {
                this.context.updateIndexed("orderStatusReasonDetailsIndexed", orderStatusReasonDetail);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Order Status Reason Detail updated successfully!", {variant: "success"});
            })
            .catch(err => {
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error updating the Order Status Reason Detail.", {variant: "error"});
                this.setState({
                    isProcessing: false,
                });
            });
    }

    async deleteOrderStatusReason() {
        this.setState({
            isProcessing: true,
        });

        return OrderStatusReasonDetailService.deleteOrderStatusReasonDetail(this.state.orderStatusReasonDetail.id)
            .then(() => {
                this.context.deleteIndexed("orderStatusReasonDetailsIndexed", this.state.orderStatusReasonDetail.id);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Order Status Reason Detail deleted successfully!", {variant: "success"});
            })
            .catch((err) => {
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error deleting the Order Status Reason Detail.", {variant: "error"});
                this.setState({
                    confirmDialogOpen: false,
                });
            });

    }

    /**
     * Render the content.
     */
    renderContent() {
        const handleChange = (orderStatusReasonDetail) => {
            this.setState({
                orderStatusReasonDetail: {
                    ...this.state.orderStatusReasonDetail,
                    ...orderStatusReasonDetail
                },
            });
        };

        return (
            <>
                <CardAdminOrderStatusReasonDetailGeneral
                    orderStatusReasonDetail={this.state.orderStatusReasonDetail}
                    onChange={handleChange.bind(this)}
                    validationIssues={this.state.validationIssues}
                />
                <DialogConfirm
                    open={this.state.confirmDialogOpen}
                    onClose={() => this.setState({ confirmDialogOpen: false })}
                    onConfirm={() => this.deleteOrderStatusReason()}
                    text="Are you sure you want to delete this Order Status Reason Detail? This cannot be undone."
                    header="Delete Order Status Reason Detail"
                    loading={this.state.isProcessing}
                />
            </>
        );
    }

    /**
    * Renders the header.
    */
    renderHeader() {
        let title;
        let subtitle;
        const buttonText = this.state.isUpdate ? "Save" : "Create";

        if (!this.state.isUpdate) {
            title = "Create Order Status Reason Detail";
            subtitle = null;
        } else {
            title = "Edit Order Status Reason Detail";
            subtitle = (this.state.orderStatusReasonDetail && (OrderStatusReasonDetail.getDisplayName(this.state.orderStatusReasonDetail) + " • " + this.state.orderStatusReasonDetail.id));
        }

        const handleClickBack = () => {
            this.props.history.goBack();
        };

        const handleClickSave = () => {
            const validationIssues = Validator.validate(
                this.state.orderStatusReasonDetail,
                {
                    name: {
                        'required': true
                    },
                    orderStatusReasonId: {
                        'required': true
                    },
                }
            );

            this.setState({
                validationIssues: validationIssues,
            });

            if (Object.keys(validationIssues).length === 0) {
                if (this.state.isUpdate) {
                    this.updateOrderStatusReason();
                } else {
                    this.createOrderStatusReason();
                }
            } else {
                NotistackEnqueueSnackbar("Please correct the displayed issues.", {variant: "error"});
            }

        };

        const handleDelete = () => {
            this.setState({
                confirmDialogOpen: true,
            });
        };

        const buttons = [
            (<MUIButton onClick={handleClickBack}>Back</MUIButton>),
            (
                <MUILoadingButton
                    loading={this.state.isProcessing}
                    loadingPosition="start"
                    onClick={handleClickSave}
                    variant="contained"
                    startIcon={<MUISaveButton />}>
                    {buttonText}
                </MUILoadingButton>
            )
        ];

        if (this.state.isUpdate) {
            const menuItems = [
                (
                    <MUIMenuItem onClick={handleDelete}>
                        <MUIListItemIcon>
                            <MUIDeleteIcon fontSize="small" />
                        </MUIListItemIcon>
                        Delete
                    </MUIMenuItem>
                )
            ];
            buttons.push((<Menu menuItems={menuItems} />));
        }

        return (
            <PageHeader title={title} subtitle={subtitle} buttons={buttons} />
        );
    }
}
